<template>
  <section class="td-car-info" :style="box">
    <div :class="container">
      <div v-if="!!description" class="td-information__description">
        <p>{{this.description}}</p>
      </div>

      <hr class="td__hr">

      <div class="td-information__table-wrapper">
        <div class="td-information__table">
          <div class="td-information__table-head">
            <div class="td-information__table-row">
              <div
                class="td-information__table-col"
                v-for="(title, idx) in titles"
                :key="idx"
              >
                <b>{{title}}</b>
              </div>
              <div class="td-information__table-col"></div>
            </div>
          </div>
          <div class="td-information__table-body">
            <div
              class="td-information__table-row"
              v-for="(row, idx) in table"
              :key="idx"
            >
              <div class="td-information__table-col">
                <span class="td-information__table-col_text">{{row.model}}</span>
              </div>

              <div class="td-information__table-col">
                <span class="td-information__table-col_text">{{row.year}}</span>
              </div>

              <div class="td-information__table-col">
                <span class="td-information__table-col_text">{{row.transmission}}</span>
              </div>

              <div v-if="!!row.link" class="td-information__table-col">
                <a :href="row.link" class="td__btn-primary">
                  <span>Verðlisti</span>
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import mixin from '@/mixins/sections/styleSettings'
export default {
  mixins: [mixin],
  data () {
    return {
      titles: ['TEGUND', 'ÁRGERÐ', 'UMBOÐ']
    }
  },
  computed: {
    // hasData to be in mixin
    table() {
      return this.hasData.rows
    },
    description() {
      return this.hasData.textarea
    }
  }
}
</script>
